<template>
	<div class="max-w-lg mx-auto px-6">
		<router-view />
	</div>
</template>

<style lang="scss">
:root {
	--global-theme-color: blue;
}
</style>
